import { Layout, Pagination } from "antd";
import { Footer } from "antd/lib/layout/layout";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";

//Internal Imports
import './EntidadesEncuesta.css';
import EntidadEncuestaItem from "../../../common/components/EntidadEncuestaItem/EntidadEncuestaItem";
import LogoBis from "../../../common/components/LogoBis/LogoBis";
import MenuHeader from "../../../common/components/MenuHeader/MenuHeader";
import SearchText from "../../../common/components/SearchText/SearchText";
import { COLORS } from "../../../common/constants/colors";
import { IContainerEntitySurvey, IEntitySurvey } from "../../../interfaces/IEntitySurvey";
import { ActiveFormListDetailByFormID, ActiveOrBlockFormListDetail, getAndBlockFormsListDetailsPagedByFormID, getFormsListDetailsPagedByFormID } from "../../../services/survey";
import { useForm } from "../../../contexts/form";
import { getError, openNotification, tryCatch } from "../../../common/constants/Utilities";
import { LoadingIcon } from "../../../common/constants/cssElements";
import LabelNotFound from "../../../common/components/Label/LabelNotFound";
import LoadingPage from "../../../common/components/LoadingPage/LoadingPage";
import { VisualizacionFormulario } from "../../../common/enums/AllEnums";
import NoticeLeavePageItem from "../../../common/components/PreventLeavePageItem/NoticeLeavePageItem";
import LoadingButton from "../../../common/components/LoadingButton/LoadingButton";


const EntidadEncuesta = () => {
    const [searchV, setSearchV] = useState<string>('');
    const [listEntitySurvey, setListEntitySurvey] = useState<IEntitySurvey[]>([]);
    const [listEntitySurveyFilter, setListEntitySurveyFilter] = useState<IEntitySurvey[]>([]);
    const [ContainerEntitySurvey, setContainerEntitySurvey] = useState<IContainerEntitySurvey>();
    const { questionForm, setEntitySurveySelected } = useForm();
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const [paginaActual, setPaginaActual] = useState<number>(1)
    const navigate = useNavigate();

    const getBodyEntitySurvey = (numberPage: number = 1) => {

        tryCatch(() => {
            setFormLoading(true);
            if (questionForm?.bloquearPaginacion) {
                getAndBlockFormsListDetailsPagedByFormID(questionForm?.formularioID!)
                    .then((response) => {
                        //Obtenemos el resultado
                        setListEntitySurvey(response.data);
                        setListEntitySurveyFilter(response.data);
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                    })
                    .finally(() => setFormLoading(false));
            } else {
                getFormsListDetailsPagedByFormID(questionForm?.formularioID!, searchV, numberPage)
                    .then((response) => {
                        //Obtenemos el resultado
                        setContainerEntitySurvey(response.data);
                        setListEntitySurvey(response.data?.resultado);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                    })
                    .finally(() => setFormLoading(false));
            }

        })
    };

    const onChange = (e: any) => {
        setPaginaActual(e); // increase the page actual
        getBodyEntitySurvey(e); //if page is 1, don't refres the page.
    }

    const onHandleButton = (entityToSurvey: IEntitySurvey) => {
        localStorage.setItem('IsLeave', JSON.stringify(false)); // Desbloqueo navegacion hacia pagina siguiente
        localStorage.removeItem('IsLeave');

        setEntitySurveySelected(entityToSurvey);
        if (questionForm?.visualizacionTipoNombre === VisualizacionFormulario.Listado) {

            if (questionForm.bloquearPaginacion === true) {

                if (questionForm.esFormularioSecuencial === true) {
                    navigate(`/SequentialSurvey`);
                } else {
                    navigate(`/EncuestaNoSequencial`);
                }

            } else {

                bloquearEntidad(entityToSurvey);
            }
        }
        if (questionForm?.visualizacionTipoNombre === VisualizacionFormulario.ListadoDetalle) {
            navigate(`/DetalleEntidadEncuestada`);
        }
    }

    const bloquearEntidad = (entityToSurvey: IEntitySurvey) => {
        tryCatch(() => {
            ActiveOrBlockFormListDetail(entityToSurvey?.formularioListadoDetalleID!, true)
                .then((response) => {
                    if (questionForm?.visualizacionTipoNombre === VisualizacionFormulario.ListadoDetalle) {

                        navigate(`/DetalleEntidadEncuestada`);
                    } else {

                        if (questionForm?.esFormularioSecuencial === true) {

                            navigate(`/SequentialSurvey`);
                        } else {

                            navigate(`/EncuestaNoSequencial`);
                        }
                    }
                })
                .catch((response) => {
                    openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                })
                .finally(() => { });
        })
    }

    // Verificar cuando el usuario abandone esta pagina.
    //NoticeLeavePageItem('Debloquear listado detalle cuando no se desplace a la siguinete pagina', formIsDirty, () => desbloquearEntidad());
    const desbloquearEntidad = () => {
        tryCatch(() => {
            if (questionForm?.bloquearPaginacion) {
                ActiveFormListDetailByFormID(questionForm.formularioID)
                    .then((response) => {
                        //Desbloqueado Formulario listado Detalle (Lista Clientes)
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', !!response?.msg ? response.msg : 'Contáctese con el equipo Bis para más información.');
                    })
                    .finally(() => { });
            }

        })
    }

    useEffect(() => {
        getBodyEntitySurvey();
        localStorage.setItem('IsLeave', JSON.stringify(true));
    }, []);

    useEffect(() => {
        return () => {
            // cuando se esta yendo de esta pagina
            const isLeavePage = JSON.parse(localStorage.getItem('IsLeave') || 'null');
            if (isLeavePage) {
                desbloquearEntidad();
            }
        }

    }, [])

    const onSubmit = () => {
        if (!questionForm?.bloquearPaginacion) {
            getBodyEntitySurvey();
            setPaginaActual(1);
        }
        else
        {
            getListEntitySurveyFiltered();
        }
    }

    const getListEntitySurveyFiltered = () => {
        let entitySurveyFiltered: IEntitySurvey[] = [];
        const valueLowerCase = searchV.toLocaleLowerCase();
        if (!!valueLowerCase) {
            entitySurveyFiltered = listEntitySurvey.filter((list) => list.nombre?.toLocaleLowerCase().includes(valueLowerCase) || list.codigo?.toLocaleLowerCase().includes(valueLowerCase))
        } else {
            entitySurveyFiltered = listEntitySurvey;
        }
        setListEntitySurveyFilter(entitySurveyFiltered);
    };

    return (

        <div >
            <div className={"nav_header"}>
                <LogoBis />
                <MenuHeader nameForm={questionForm?.nombre} currentPage={questionForm?.listadoNombre!} isMenu={false} />
            </div>
            <div className={"entitySurvey_container"}>
                
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div style={{ flex: '90%' }}>
                        <SearchText
                            value={searchV}
                            active={true}
                            borderColor={COLORS.black_back_color5}
                            textColor={COLORS.black_text_color1}
                            placeholdercolor={COLORS.black_text_color4}
                            name={"search_table"}
                            onChange={setSearchV}
                            placeholder={"Buscar"}
                            backgroundcolor={COLORS.black_back_color5}
                            opacity={1}
                            props={{ collapsed: 'false' }}
                        />
                    </div>
                    <div style={{ flex: '10%', marginLeft: '10px' }}>
                        <LoadingButton
                            title={"Buscar"}
                            background={COLORS.blue_active}
                            color={COLORS.white_color1}
                            loading={formLoading.toString()}
                            method={() => onSubmit()}
                            fontsize={18}
                            type={'button'}
                            disabled={formLoading}
                        />
                    </div>
                </div>
                {formLoading.toString() === 'true'
                    ? <div className="loading-container"> <LoadingPage message="Cargando..." /></div>
                    : (questionForm?.bloquearPaginacion ? listEntitySurveyFilter : listEntitySurvey)?.length !== 0 ?
                        <div className="entitySurvey_container_data">
                            {
                                (questionForm?.bloquearPaginacion ? listEntitySurveyFilter : listEntitySurvey).map((entitySurvey: IEntitySurvey) =>
                                    <EntidadEncuestaItem key={entitySurvey.formularioListadoDetalleID} codigo={entitySurvey.codigo} nombre={entitySurvey.nombre} active={true} textColor={COLORS.blue_active} method={() => onHandleButton(entitySurvey)} />
                                )
                            }
                        </div>
                        : <LabelNotFound message="No se encontró data." />
                }

            </div>
            <Layout>
                <Footer className={"entitySurvey_footer"}>
                    {!questionForm?.bloquearPaginacion &&
                        <div className={"footer-column-1"}>
                            <h3>CANTIDAD DE REGISTROS</h3>
                            <h2>{ContainerEntitySurvey?.totalRegistros}</h2>
                        </div>
                    }

                    {!questionForm?.bloquearPaginacion &&
                        <div className={"footer-column-2"}>
                            <h3>PÁGINAS</h3>
                            <Pagination
  onChange={onChange}
  current={paginaActual}
  total={(ContainerEntitySurvey?.totalPaginas && !isNaN(ContainerEntitySurvey.totalPaginas) ? ContainerEntitySurvey.totalPaginas * 10 : 0)}
  showSizeChanger={false}
/>
                        </div>
                    }
                    {
                        <div className={"footer-column-3"}>
                            <h3>HASTA</h3>
                            <h2>{new Date(questionForm!.fechaHasta).toLocaleDateString()}</h2>
                        </div>
                    }
                </Footer>
            </Layout>
        </div >
    )
}
export default EntidadEncuesta;